import { render, staticRenderFns } from "./TrustBadges.vue?vue&type=template&id=2309a174&scoped=true&"
import script from "./TrustBadges.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TrustBadges.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TrustBadges.vue?vue&type=style&index=0&id=2309a174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309a174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2309a174')) {
      api.createRecord('2309a174', component.options)
    } else {
      api.reload('2309a174', component.options)
    }
    module.hot.accept("./TrustBadges.vue?vue&type=template&id=2309a174&scoped=true&", function () {
      api.rerender('2309a174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/TrustBadges/TrustBadges.vue"
export default component.exports